<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div class="page-header">
    <h4 class="page-header__title">{{ $t(title) }}</h4>
  </div>
</template>

<style scoped>
.page-header {
  padding: 0;
  margin-bottom: 12px;
}

.page-header__title {
  font-size: 18px;
  font-weight: 600;
  color: var(--vz-body-color);
  margin: 0;
  letter-spacing: -0.01em;
}

/* Темна тема */
[data-layout-mode="dark"] .page-header__title {
  color: #ced4da;
}
</style>
